module.exports = __webpack_public_path__ + "01ea978f/img/share-icon.0f8a11b4.svg";